/*
 * @Author: cc
 * @LastEditTime: 2025-07-10 11:14:08
 */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
/**一体化组件 */
import Integration from "../component/integration";
/**独立密码组件 */
import Independent from "../component/independent";
import "./index.scss";
import { connect } from "react-redux";
import { Button, Modal } from "antd";
import { useState } from "react";
export const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};
/**登录页面组件 */
function Login(props: any) {
  // const projectId = query.get('projectId')
  const infoData = props.initData;
  const [videoModal, setVideoModal] = useState(false);
  const [currentVideo, setCurrentVideo] = useState(null);
  const initVideo = (vid: string) => {
    if (window.createCCH5Player) {
      window.ccPlayerStatus = window.createCCH5Player({
        vid,
        siteid: "D71B0368E20B4CF5",
        autoStart: true,
        width: "100%",
        height: "300px",
        banDrag: "false",
        playtype: 1,
        rate_allow_change: false,
        parentNode: document.getElementById("livePlayer"),
      });
    }
  };
  useEffect(() => {
    if (videoModal) {
      initVideo(currentVideo.adContent);
    }
  }, [currentVideo]);
  return (
    <>
      <div className="mobileWrapper">
        {infoData.mobileTopImageUrl && (
          <img
            style={{ width: "60%", margin: "20px 0", maxHeight: "100px" }}
            src={infoData.mobileTopImageUrl}
            alt=""
          ></img>
        )}
        <div className="content">
          <img
            style={{ maxHeight: "200px" }}
            src={infoData.mobileMainImageUrl}
            alt=""
          ></img>
          <div className="login">
            {infoData.verifyLoginMode === 1 ? (
              <Integration></Integration>
            ) : (
              <Independent></Independent>
            )}
          </div>
        </div>
        {infoData.mobileBottomImageUrl && (
          <img
            style={{ marginTop: "20px", width: "60%", maxHeight: "80px" }}
            src={infoData.mobileBottomImageUrl}
            alt=""
          ></img>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          {infoData.adPositionName && (
            <h2 style={{ marginTop: "20px" }}>{infoData.adPositionName}</h2>
          )}
          {infoData.adPositionInfoList &&
            infoData.adPositionInfoList.map((item: any, index: number) => {
              return (
                <a
                  style={{ display: "block", width: "100%" }}
                  onClick={() => {
                    if (item.adMode === 2) {
                      setVideoModal(true);
                      setCurrentVideo(item);
                    } else {
                      window.location.href = item.adContent;
                    }
                  }}
                  key={index}
                >
                  <img
                    style={{
                      width: "50%",
                      display: "block",
                      margin: "20px auto 0",
                    }}
                    src={item.adImageUrl}
                    alt=""
                  ></img>
                </a>
              );
            })}
        </div>
      </div>
      <Modal
        open={videoModal}
        closable={false}
        cancelText="关闭"
        onOk={() => {
          setVideoModal(false);
        }}
        onCancel={() => {
          setVideoModal(false);
        }}
      >
        <div id="livePlayer"></div>
      </Modal>
    </>
  );
}
const getInitData = (state: { initData: Array<any> }) => {
  return {
    initData: state.initData,
  };
};
export default connect(getInitData)(Login);
